// extracted by css-extract-rspack-plugin
export default {"nativeSidebar":"_uTFR","nativeSidebarToggle":"vXX7I"};